var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEvidenceRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_raw_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_raw_group2",
    transform: "translate(-1177.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_raw_group3",
    transform: "translate(1177.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon_evidence_raw_rect1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_raw_group4",
    transform: "translate(2.000000, 4.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,3 L2,5 C2,5.55 1.55,6 1,6 L0,6 L0,10 L1,10 C1.55,10 2,10.45 2,11 L2,13 C2,14.65 3.35,16 5,16 L8,16 L8,14 L5,14 C4.45,14 4,13.55 4,13 L4,11 C4,9.7 3.16,8.58 2,8.17 L2,7.83 C3.16,7.42 4,6.3 4,5 L4,3 C4,2.45 4.45,2 5,2 L8,2 L8,0 L5,0 C3.35,0 2,1.35 2,3 Z",
    id: "icon_evidence_raw_path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,6 C18.45,6 18,5.55 18,5 L18,3 C18,1.35 16.65,0 15,0 L12,0 L12,2 L15,2 C15.55,2 16,2.45 16,3 L16,5 C16,6.3 16.84,7.42 18,7.83 L18,8.17 C16.84,8.58 16,9.69 16,11 L16,13 C16,13.55 15.55,14 15,14 L12,14 L12,16 L15,16 C16.65,16 18,14.65 18,13 L18,11 C18,10.45 18.45,10 19,10 L20,10 L20,6 L19,6 Z",
    id: "icon_evidence_raw_path2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvidenceRaw);
export default __webpack_public_path__ + "static/media/icon_evidence_raw.e898ee1f.svg";
export { ForwardRef as ReactComponent };